import React, { useState, useRef, useEffect } from 'react';
import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import { Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../redux/dashboard/action';

function FilterDropdown() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  // const selected = globalChannel || [];
  const dispatch = useDispatch();
  const globalChannel = useSelector((state) => state.dashboard.channel);
  const profile = useSelector((state) => state.auth.profile);
  const connectedChannels = profile?.connected_channels || [];
  const [tempSelected, setTempSelected] = useState([]);

  const options = connectedChannels.length > 0 ? ['Select All', ...connectedChannels] : [];
  const allOptions = connectedChannels;
  // const handleCheckbox = (value) => {
  //   if (value === 'Select All') {
  //     if (selected.length === allOptions.length) {
  //       setSelected([]);
  //     } else {
  //       setSelected(allOptions);
  //     }
  //   } else {
  //     setSelected((prev) => (prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]));
  //   }
  // };
  const handleCheckbox = (value) => {
    let updated = [];

    if (value === 'Select All') {
      if (tempSelected.length === allOptions.length) {
        updated = [];
      } else {
        updated = allOptions;
      }
    } else {
      updated = tempSelected.includes(value) ? tempSelected.filter((item) => item !== value) : [...tempSelected, value];
    }

    setTempSelected(updated);
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (connectedChannels.length > 0 && (!globalChannel || globalChannel.length === 0)) {
      setTempSelected(connectedChannels);
      dispatch(actions.setChannel(connectedChannels));
    }
  }, [connectedChannels, globalChannel, dispatch]);

  useEffect(() => {
    if (globalChannel && globalChannel.length > 0) {
      setTempSelected(globalChannel);
    }
  }, [globalChannel]);

  // useEffect(() => {
  //   if (connectedChannels.length === 0) {
  //     if (tempSelected.length > 0) {
  //       setTempSelected([]);
  //     }
  //     return;
  //   }

  //   if (globalChannel?.length > 0) {
  //     if (JSON.stringify(tempSelected) !== JSON.stringify(globalChannel)) {
  //       setTempSelected(globalChannel);
  //     }
  //     return;
  //   }

  //   if (JSON.stringify(tempSelected) !== JSON.stringify(connectedChannels)) {
  //     setTempSelected(connectedChannels);
  //   }

  //   if (!globalChannel?.length) {
  //     dispatch(actions.setChannel(connectedChannels));
  //   }
  // }, [connectedChannels, globalChannel, tempSelected, dispatch]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="cursor-pointer p-2 rounded-md flex items-center justify-center"
      >
        {/* {selected.length > 0 && <span className="text-xs font-medium text-gray-600">{selected.length}</span>} */}
        {tempSelected.length > 0 && <span className="text-xs font-medium text-gray-600">{tempSelected.length}</span>}
        <UilAngleDown className="w-5 h-5" />
      </button>

      {open && (
        <div className="absolute left-0 w-48 bg-white shadow-lg rounded-lg p-3 z-50">
          {connectedChannels.length === 0 ? (
            <div className="px-2 py-4 text-sm text-gray-500 text-center">No channel connected</div>
          ) : (
            options.map((item) => (
              <label
                key={item}
                className="flex items-center gap-2 px-2 py-3 leading-none rounded cursor-pointer hover:bg-blue-50 w-full"
              >
                <Checkbox
                  checked={
                    item === 'Select All' ? tempSelected.length === allOptions.length : tempSelected.includes(item)
                  }
                  onChange={() => handleCheckbox(item)}
                  className="!m-0"
                />

                <span className="text-sm flex items-center cursor-pointer flex-1">{item}</span>
              </label>
            ))
          )}

          <div className="border-t my-2" />

          <div className="flex justify-center">
            <button
              type="button"
              disabled={connectedChannels.length === 0}
              onClick={() => {
                dispatch(actions.setChannel(tempSelected));
                setOpen(false);
              }}
              className={`text-white text-sm px-4 py-1.5 rounded-md ${
                connectedChannels.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'cursor-pointer'
              }`}
              style={
                connectedChannels.length > 0
                  ? {
                      background: 'linear-gradient(135deg, rgb(16, 185, 129) 0%, rgb(15, 118, 110) 100%)',
                    }
                  : undefined
              }
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterDropdown;
